module.exports = __webpack_public_path__ + "static/media/favicon.a19eedcd.ico";